import { graphql } from 'src/graphql';

export const RevokeParticipantInvitation = graphql(`
  mutation revokeParticipantInvitation($participant_session_id: ID!, $sms_message: String!) {
    revokeParticipantInvitation(participant_session_id: $participant_session_id, sms_message: $sms_message) {
      _id
      status
      session {
        _id
        booking {
          _id
        }
      }
    }
  }
`);
